export enum TipoCertificado {
    Ganancias,
    IIBBObraSocialMunicipal
}